import Counter from 'src/internal/platformMetrics/aggregators/Counter';

export const safeParams = ['request', 'miss'] as const;

type SafeParams = (typeof safeParams)[number];

export const translationCount = new Counter<SafeParams>(
  'i18n_translation_format_message_total',
);
